"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var stripUnit = function stripUnit(value, unitReturn) {
  var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
  if (typeof value !== 'string') return unitReturn ? [value, undefined] : value;
  var matchedValue = value.match(cssRegex);

  if (unitReturn) {
    if (matchedValue) return [parseFloat(value), matchedValue[2]];
    return [value, undefined];
  }

  if (matchedValue) return parseFloat(value);
  return value;
};

var value = function value() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      param = _ref.param,
      rootSize = _ref.rootSize,
      _ref$outputUnit = _ref.outputUnit,
      outputUnit = _ref$outputUnit === void 0 ? 'rem' : _ref$outputUnit;

  if (!param && param !== 0) return;

  var _stripUnit = stripUnit(param, true),
      _stripUnit2 = _slicedToArray(_stripUnit, 2),
      value = _stripUnit2[0],
      unit = _stripUnit2[1];

  if (!value && value !== 0) return;
  if (value === 0 || typeof value === 'string') return param; // zero should be unitless

  if (!unit && !isNaN(value)) return "".concat(value / rootSize, "rem");
  if (unit === 'px' && outputUnit === 'rem') return "".concat(value / rootSize, "rem");
  if (unit) return param;
  return "".concat(value).concat(outputUnit);
};

var _default = value;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/coolgrid/dist/utils/units.js
// module id = 64
// module chunks = 0